__turbopack_context__.v({
  "container": "jPIFiG_container",
  "heading": "jPIFiG_heading",
  "headingMain": "jPIFiG_headingMain",
  "headingSubtitle": "jPIFiG_headingSubtitle",
});
